export default __webpack_public_path__ + "media/images/contact-vert-6cc3b39343083de9f88e5753fb3315d8.png";